import React from 'react'
import {Routes, Route, Navigate} from 'react-router-dom'
import HomePage from './pages/HomePage.tsx'
import LoginPage from "./pages/LoginPage.tsx";
import RegisterPage from "./pages/RegisterPage.tsx";
import CategoryPage from "./pages/Category.tsx";
import ProductPage from "./pages/ProductPage.tsx";
import PrivateRoute from "./components/PrivateRoute.tsx";
import EditProductPage from "./pages/EditProductPage.tsx";
import CreateProductPage from "./pages/CreateProductPage.tsx";
import CartPage from "./pages/CartPage.tsx";
import CheckoutPage from "./pages/CheckoutPage.tsx";
import OrderPage from "./pages/OrderPage.tsx";
import ProfilePage from "./pages/ProfilePage.tsx";
import VerifyEmail from "./pages/VerifyEmail.tsx";
import VerificationMailSendPage from "./pages/VerificationMailSend.tsx";
import PrivacyPolicy from "./pages/PrivacyPolicy.tsx";
import Imprint from "./pages/Imprint.tsx";
import Gtc from "./pages/Gtc.tsx";
import Revocation from "./pages/Revocation.tsx";
import CreateSalePage from "./pages/CreateSalePage.tsx";
import EditSalePage from "./pages/EditSalePage.tsx";
import CreateDiscountCodePage from "./pages/CreateDiscountCodePage.tsx";
import ShippingConditions from "./pages/ShippingConditions.tsx";
import CreateReviewPage from "./pages/CreateReviewPage.tsx";
import EditReviewPage from "./pages/EditReviewPage.tsx";

const AppRoutes: React.FC = () => {
    return (
        <Routes>
            <Route path='/' element={<HomePage/>}/>
            <Route path='/login' element={<LoginPage/>}/>
            <Route path='/register' element={<RegisterPage/>}/>
            <Route path='/verificationMailSend' element={<VerificationMailSendPage/>}/>
            <Route path="/verify-email/:token" element={<VerifyEmail/>}/>
            <Route path='/profile'
                   element={<PrivateRoute element={<ProfilePage/>}/>}/>
            <Route path='/category/:category' element={<CategoryPage/>}/>
            <Route path='/product/:id' element={<ProductPage/>}/>
            <Route path='/cart' element={<CartPage/>}/>
            <Route path='/checkout' element={<CheckoutPage/>}/>
            <Route path='/order/:id' element={<OrderPage/>}/>
            <Route path="/edit-product/:id"
                   element={<PrivateRoute element={<EditProductPage/>} roleRequired="admin"/>}/>
            <Route path='/create-product'
                   element={<PrivateRoute element={<CreateProductPage/>} roleRequired="admin"/>}/>
            <Route path='/create-Sale'
                   element={<PrivateRoute element={<CreateSalePage/>} roleRequired="admin"/>}/>
            <Route path='/create-discount-code'
                   element={<PrivateRoute element={<CreateDiscountCodePage/>} roleRequired="admin"/>}/>
            <Route path='/edit-sale/:id'
                   element={<PrivateRoute element={<EditSalePage/>} roleRequired="admin"/>}/>
            <Route path="*" element={<Navigate to="/" replace/>}/>
            <Route path='/privacy-policy' element={<PrivacyPolicy/>}/>
            <Route path='/imprint' element={<Imprint/>}/>
            <Route path='/gtc' element={<Gtc/>}/>
            <Route path='/revocation' element={<Revocation/>}/>
            <Route path='/shippingConditions' element={<ShippingConditions/>}/>
            <Route path='/create-review/:orderId' element={<CreateReviewPage/>}/>
            <Route path='/edit-review/:reviewId/of/:orderId' element={<EditReviewPage/>}/>
        </Routes>
    );
};

export default AppRoutes
